import {State} from "./types";
import {setRequestStatus} from "../request-status";

export const initialState: State = {
  payments: [],
  banks: [],
  pagination: {
    pos: 0,
    lim: 20,
    ser: "",
    hasMore: true,
  },
  request: {
    banks: setRequestStatus("initial"),
    payments: setRequestStatus("initial"),
  },
};
